import React, { useMemo } from 'react'
import { Grid } from '@material-ui/core'
import { useParams } from 'react-router-dom'
import PropTypes from 'prop-types'
import PageLayout from '../../common/PageLayout'
import PageHeading from '../../common/PageHeading'
import Divider from '../../../../../components/atoms/Divider'
import { useRunAiScheduledPrompt, useScheduledPromptById } from '../../../../../api/denaliAssistant'
import Loading from '../../../../../components/molecules/Loading'
import SydButton from '../../../../../components/commonDesign/Button'
import MessageById from '../../common/MessageById'
import SydLinkButton from '../../../../../components/commonDesign/LinkButton'

const moodStyle = {
  backgroundColor: 'var(--color-texture-300)',
  boxShadow: 'var(--shadow-lg)',
  marginTop: 'var(--margin-md)',
  borderRadius: 'var(--border-radius-md)',
  padding: 'var(--padding-lg)'
}

function ScheduleDetail ({ showMood }) {
  const { scheduleId } = useParams()
  const { data, isLoading } = useScheduledPromptById(scheduleId, {
    lastResponse: true
  })
  const { mutateAsync: runScheduledPrompt, isLoading: isRunning } = useRunAiScheduledPrompt()
  const info = useMemo(() => {
    const prompt = data?.scheduledPrompt || {}
    return {
      parentInfo: {
        parentId: prompt?.scheduleId,
        parentType: 'schedule'
      },
      messageId: data?.lastResponse?.threadMessageId,
      prompt
    }
  }, [data])

  const prompt = info?.prompt
  return (
    <PageLayout variant='constrained'>
      {isLoading ? (
        <Loading />
      ) : (
        <div style={showMood ? moodStyle : {}}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <PageHeading title={prompt.name}>
                <SydLinkButton
                  icon='edit'
                  size='md'
                  variant='ghost'
                  to={`/denali-ai/schedules/${scheduleId}/edit`}
                >
                  Edit
                </SydLinkButton>
                <SydButton
                  icon='sync'
                  size='md'
                  variant='outline'
                  processing={isRunning}
                  onClick={() => runScheduledPrompt({ scheduleId }).catch(console.error)}
                >
                  Generate
                </SydButton>
              </PageHeading>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              {info?.messageId ? (
                <MessageById
                  parentInfo={info.parentInfo}
                  messageId={info.messageId}
                  hideMessageHeader
                />
              ) : (
                <div className='flex justify-center items-center p-lg font-color-disabled'>
                  <em>This prompt hasn't been run yet</em>
                </div>
              )}
            </Grid>
          </Grid>
        </div>
      )}
    </PageLayout>
  )
}

ScheduleDetail.propTypes = {
  showMood: PropTypes.bool
}

ScheduleDetail.defaultProps = {
  showMood: false
}

export default ScheduleDetail
